import { api } from './api';
import { OrgInfo, useNova } from './store';
import type { Disposition, Person, QueueRow } from './types';

/**
 * Loads the lists every screen relies on: the organization, outcomes, break
 * reasons, queues and people. Called at sign-in and after an admin changes
 * any of them, so agents see the new lists without reloading.
 */
export async function loadReference(): Promise<boolean> {
  const store = useNova.getState();
  try {
    const [me, dispositions, breakReasons, queues, people] = await Promise.all([
      api<{ user: { email: string }; org: OrgInfo }>('GET', '/me'),
      api<Disposition[]>('GET', '/dispositions'),
      api<Disposition[]>('GET', '/break-reasons'),
      api<QueueRow[]>('GET', '/queues'),
      api<Person[]>('GET', '/agents'),
    ]);
    store.set({
      org: me.org,
      email: me.user.email,
      dispositions,
      breakReasons,
      queueList: queues,
      people: Object.fromEntries(people.map((p) => [p.id, p])),
    });
    return true;
  } catch (err) {
    store.toast((err as Error).message, 'error');
    return false;
  }
}
